import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import { PageArticle } from "@/components/contentful/page-article/page-article";
import type { CoreGraphqlEntryProps } from "@/types/page";
import { usePageArticleQuery } from "@/components/contentful/page-article/__generated/page-article.contentful.generated";
import { type MicrocopyInputType } from "@/lib/contentful/microcopy/microcopy-context";

type PageArticleGraphqlProps = CoreGraphqlEntryProps;

export const PageArticleGraphql = ({ id, locale, preview }: PageArticleGraphqlProps) => {
    const { data, isLoading } = usePageArticleQuery(
        {
            id,
            locale,
            preview,
        },
        {
            ...(!preview && { staleTime: Infinity }),
            refetchOnWindowFocus: false,
        }
    );

    const queryResult = useContentfulLiveUpdates(data, { locale });

    const microcopySets: MicrocopyInputType[] =
        queryResult?.microcopySetCollection?.items?.filter((item) => item !== null) ?? [];

    if (isLoading || !queryResult?.page) {
        return null;
    }

    return <PageArticle {...queryResult?.page} microcopySets={microcopySets} />;
};
